'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _View2 = require('../view/View');

var _View3 = _interopRequireDefault(_View2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _jquery = require('jquery/src/jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('react-trumbowyg/dist/trumbowyg.css');

var _reactTrumbowyg = require('react-trumbowyg');

var _reactTrumbowyg2 = _interopRequireDefault(_reactTrumbowyg);

require('trumbowyg/dist/langs/pt_br.min.js');

require('./trumbowyg.fontfamily');

require('trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.js');

require('trumbowyg/dist/plugins/base64/trumbowyg.base64.js');

require('trumbowyg/dist/plugins/colors/trumbowyg.colors.js');

require('trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css');

require('../../assets/css/components/form/RichTextEditor.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//https://github.com/RD17/react-trumbowyg
//https://alex-d.github.io/Trumbowyg/documentation

// import 'trumbowyg/dist/plugins/fontfamily/trumbowyg.fontfamily.js'

// import '../../../node_modules/trumbowyg/dist/trumbowyg.js'
// import '../../../node_modules/trumbowyg/dist/ui/trumbowyg.min.css'


var RichTextEditor = function (_View) {
    _inherits(RichTextEditor, _View);

    function RichTextEditor(props) {
        _classCallCheck(this, RichTextEditor);

        var _this = _possibleConstructorReturn(this, (RichTextEditor.__proto__ || Object.getPrototypeOf(RichTextEditor)).call(this, props));

        _this.removeScript = function (html) {
            var newHTML = html.replace(/<script[\s\S]*?>/gi, '&lt;script&gt;');
            newHTML = newHTML.replace(/<\/script[\s\S]*?>/gi, '&lt;/script&gt;');
            return newHTML;
        };

        _this.onChange = function (e) {
            _this.props.onChange(_this.removeScript(e.target.innerHTML));
        };

        _this.onPaste = function (e) {
            _this.onChange(e);
        };

        _this.state = {
            data: '',
            initData: null
        };
        return _this;
    }

    _createClass(RichTextEditor, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.data !== undefined && nextProps.data.length > 0 && this.state.initData === null && this.isActionUpdate()) {
                this.setState({
                    data: this.removeScript(nextProps.data),
                    initData: this.removeScript(nextProps.data)
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ data: this.removeScript(this.props.data || "") });
            (0, _jquery2.default)('.trumbowyg-fontsize-button')[0].innerHTML = "T";
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_reactTrumbowyg2.default, { id: 'react-trumbowyg', lang: 'pt_br',
                buttons: [['fontfamily', 'fontsize', 'strong', 'em', 'del', 'formatting'], ['foreColor', 'backColor'], ['superscript', 'subscript'], ['link'],
                // ['insertImage','base64'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'], ['unorderedList', 'orderedList'], ['horizontalRule'], ['removeformat'], ['undo', 'redo']],
                data: this.state.data,
                placeholder: this.props.placeholder || '',
                onChange: this.onChange,
                onPaste: this.onPaste,
                prefix: 'modern-ui'
            });
        }
    }]);

    return RichTextEditor;
}(_View3.default);

exports.default = (0, _reactRouter.withRouter)(RichTextEditor);


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/form/RichTextEditor.js
// module id = 1125
// module chunks = 0